import Select2BaseController from './base_controller'

const formatStateTags = ({ id, text, element }) => {
  if (!id) {
    return text
  }
  const $state = $(
    `<span>
      <span class="material-symbols-outlined item-tag" style="color:${element.dataset.color};vertical-align:text-top;">sell</span>
      ${text}
    </span>`
  )
  return $state
}

// select2 Search Dropdown with Tags
// Usage: add "data-controller="select2--tags"" attribute to an HTML element
export default class extends Select2BaseController {
  connect() {
    $(this.element).select2({
      theme: 'bootstrap4',
      width: '100%',
      allowClear: true,
      templateResult: formatStateTags,
      templateSelection: formatStateTags,
      placeholder: $(this.element).attr('placeholder') || '',
      selectionCssClass: 'select2-custom-selection',
      dropdownCssClass: 'select2-custom-dropdown',
    })

    super.connect()
  }
}
